import React, {useMemo} from 'react';
import styled, {css} from 'styled-components';

import SbEditable from 'components/SbEditableExtended';
import StoryblokClient from 'storyblok-js-client';

import ContentWrapper from 'components/contentWrapper';
import Icon from 'components/icons/icon';
import ContentArea from 'components/contentArea';

import config from 'settings/config';
import theme, {bp, color} from 'settings/theme';

let Storyblok = new StoryblokClient({
    accessToken: config.storyBlok.publicToken
})


type Props = {
  product: any,
  showContent?: boolean
};



// Product Header
const Component: React.FC<Props> = (props) => {

  return (
    <StyledComponent className="productDetails spacingTop">

      <ContentWrapper>

        <div className="productDetails-descLayout">

          {/* Description */}
          <div className="productDetails-descLayout-desc">

            <h3 className="spacingBottomHalf">Product Description</h3>

            {props.product?.content?.description &&
              <SbEditable content={props.product.content}>
                <div className="content" dangerouslySetInnerHTML={{__html: Storyblok.richTextResolver.render(props.product.content.description)}} />
              </SbEditable>
            }

          </div>


          {/* Key Features */}
          {props.product?.content?.key_features && props.product?.content?.key_features.length > 0 &&
            <SbEditable content={props.product.content}>

                <div className="productDetails-descLayout-features spacingBottom">

                  <h3 className="spacingBottomHalf">Key Features</h3>

                  <ul className="productDetails-features">

                    {props.product.content.key_features.split(/\r?\n/).map((feature, index) => (
                      <li key={index}>
                        <span><Icon iconName="star" /></span>
                        <span>{feature}</span>
                      </li>
                    ))}

                  </ul>

                </div>

              </SbEditable>
          }


        </div>


        {/* Related Products */}
        {/* {props.pageData.content.top_products && props.pageData.content.top_products.length > 0 &&
            
          <div>

            <ContentWrapper>
              <h3 className="spacingBottomHalf">Top Selling Products In {content.name}</h3>
            </ContentWrapper>

            <ContentWrapper fullWidthAt={[1,2]}>
              <Grid className="spacingBottom">
                {props.pageData.content.top_products.map(item => (
                  <ProductCard
                    key={item.uuid}
                    product={item}
                  />
                ))}
              </Grid>
            </ContentWrapper>

          </div>
            
        } */}


      </ContentWrapper>

      {/* Content  */}
      {props.showContent === true &&
        <ContentArea content={props.product?.content?.content} />
      }

    </StyledComponent>
  );

}

Component.defaultProps = {
    showContent: true
}

export default Component




// Styles
const StyledComponent = styled.div`

  display: block;
  
  .productDetails-descLayout{
    display: flex;
    flex-direction: column-reverse;  
  }

  .productDetails-features{

    li{
      display: flex;
      align-items: center;
      margin-bottom: 0.2rem;
      white-space: nowrap;
    }

    span{

      display: inline-block;
      vertical-align: text-top;
      white-space: break-spaces;

      &:first-child{
        margin-right: 10px;
      }

      &:last-child{
        padding-top: 2px;
      }

    }

    .icon{

      width: 16px;
      height: 16px;

      svg{
        fill: ${color.primary};
      }

    }

  }

  @media (min-width: ${bp(3)}) {

    .productDetails-descLayout{
      flex-direction: row;
    }

    .productDetails-descLayout-desc{
      flex: 1 1 auto;
    }

    .productDetails-descLayout-features{
      flex: 1 0 220px;
      margin-left: 40px;
    }

    .productDetails-features{
      li{
        margin-bottom: 0.8rem;
      }
    }

  }

  @media (min-width: ${bp(4)}) {

    .productDetails-descLayout-features{
      flex-basis: 300px;
      margin-left: 60px;
      margin-bottom: 0;
    }

  }


`



